import { Component, ElementRef, HostBinding, OnInit } from '@angular/core';

import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import { NotificationService } from 'src/app/Service/notification.service';

import { OtherService } from 'src/app/Service/other.service';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import Map from 'ol/Map';

import View from 'ol/View';

import * as olProj from 'ol/proj';

import {

  DragRotateAndZoom,

  defaults as defaultInteractions,

} from 'ol/interaction';


import Feature from 'ol/Feature';

import { Tile as TileLayer } from 'ol/layer';

import OSM from 'ol/source/OSM';

import { Point } from "ol/geom";

import { BingMaps, Cluster, Vector } from "ol/source";

import AnimatedCluster from "ol-ext/layer/AnimatedCluster";

import SelectCluster from "ol-ext/interaction/SelectCluster";

import { Tile } from "ol/layer";

import { Circle, Fill, Icon, Stroke, Style, Text } from "ol/style";

import "ol/ol.css";

import VectorSource from "ol/source/Vector";

import VectorLayer from "ol/layer/Vector";

import axios from 'src/app/Service/axios';

import momentJalaali from 'moment-jalaali';

declare let $: any;

@Component({

  selector: 'app-inspection-search',

  templateUrl: './inspection-search.component.html',

  styleUrls: ['./inspection-search.component.css']

})

export class InspectionSearchComponent implements OnInit {

  list_ResultItems = [];

  list_Inspections = [];

  list_InspSearch = [];

  list_Items = [];

  lstFInspection_Result: any[] = [];

  lstPeriodicVisits_Result: any[] = [];

  list_ValueItems = [];

  bVisits: boolean = false;

  bValidation: boolean = false;

  bViewMode: boolean = false;

  validation_Obj: any = {};

  validationMap: any;

  searchModel: FormGroup = this.formBuilder.group({

    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

    strSDate: new FormControl(momentJalaali().format('jYYYY/jMM/jDD')),

    strEDate: new FormControl(momentJalaali().format('jYYYY/jMM/jDD')),

    tiFInspection_ResultItem: new FormControl('-1'),

  })

  inspection_Model: FormGroup = this.formBuilder.group({

    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

    iFInspection: new FormControl(''),

    strUnitID: new FormControl(''),

    fLat: new FormControl(0),

    fLon: new FormControl(0),

    strComment: new FormControl(''),

    tiFirst_FInspection_ResultItem: new FormControl(''),

    tiSecound_FInspection_ResultItem: new FormControl(''),

    strDeadlineDate: new FormControl(''),

    bBodyinsurance: new FormControl(false),

    bThirdInsurance: new FormControl(false),

    strInsuranceValidityDate: new FormControl(''),

    strEquipmentInspector: new FormControl(''), // ======> نام بازرس تجهیزات

    strSafetyInspector: new FormControl(''), // ======> نام بازرس ایمنی

    lstFInspection_Result: new FormControl('')

  })

  periodicVisits_Model: FormGroup = this.formBuilder.group({

    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

    iPeriodicVisits: new FormControl(''),

    strUnitID: new FormControl(''),

    fLat: new FormControl(0),

    fLon: new FormControl(0),

    strComment: new FormControl(''),

    lstPeriodicVisits_Result: new FormControl('')

  })

  constructor(

    private notifyService: NotificationService,

    private router: Router,

    public otherService: OtherService,

    private route: ActivatedRoute,

    private formBuilder: FormBuilder,

    private gurdService: GurdServiceService

  ) { }

  ngOnInit(): void {

    this.route.url.subscribe((segment: any) => {

      if (segment[0].path == 'periodic-visits') {

        this.bVisits = true;

        this.getInspection_Item();

      }

      if (segment[0].path == 'validation') {

        this.bValidation = true;

      }

      if (segment[0].path == 'inspection-search') {

        this.getInspection_Item();

      }

      this.getInspection_ResultItem();

    })

  }

  getInspection_ResultItem = async () => {

    this.otherService.Showspinner();

    const response = await axios.post(`FInspection_ResultItem_List?tiType=${0}`);

    let res = JSON.parse(response.data);

    this.list_ResultItems = res;

    this.otherService.nonespinner()

  }

  searchInspection = async () => {

    var model = this.searchModel.value;

    if (model.strSDate == '' || model.strEDate == '') return this.notifyService.showError('لطفا تاریخ را وارد کنید')

    this.otherService.Showspinner();

    const URL_SEGMENT = this.bValidation ? 'Mobile_Validation_Search' :

      this.bVisits ? 'PeriodicVisits_Search' : 'FInspection_Search';

    const response = await axios.post(URL_SEGMENT, model);

    this.otherService.nonespinner();

    let res = JSON.parse(response.data);

    if (res.iResult == 0) return this.notifyService.showError(res.strError)

    this.list_Inspections = res;

    this.list_InspSearch = res;

  }

  filter_list(val: any) {

    this.list_Inspections = this.list_InspSearch.filter((el: any) => {

      return el.strFullName.includes(val.value) ||

        el.strVehicleNo.includes(val.value) ||

        el.strFirst_FInspection_ResultItem_strComment.includes(val.value) ||

        el.strSecound_FInspection_ResultItem_strComment.includes(val.value) ||

        el.strMobileType_strComment.includes(val.value)

    });

    if (val.value.trim() == '') {

      this.list_Inspections = this.list_InspSearch;

    }

  }

  getInspection_Item = async () => {

    // کل ایتم ها و گزینه ها برای چیدمان در صفحه

    this.otherService.Showspinner();

    const response = await axios.post(`FInspection_Items_List`, this.searchModel.value);

    let res = JSON.parse(response.data);

    this.list_Items = res;

    this.initial_List_Result();

    this.otherService.nonespinner()

  }

  initial_List_Result() {

    this.list_Items.forEach((el: any) => {

      this.lstFInspection_Result.push({

        iFInspection_Items: el.iFInspection_Items,

        strComment: '',

        strFInspection_Items_Title: '',

        tiFInspection_Items_Title_Index: '',

        strImage: '',

        strVoice: '',

        bImageRequired: el.tiImageRequired == 2 ? true : false,

        bVoiceRequired: el.tiVoiceRequired == 2 ? true : false

      })

    })

    // periodic visits

    this.list_Items.forEach((el: any) => {

      this.lstPeriodicVisits_Result.push({

        iPeriodicVisits: el.iPeriodicVisits,

        iFInspection_Items: el.iFInspection_Items,

        strComment: '',

        strFInspection_Items_Title: '',

        tiFInspection_Items_Title_Index: '',

        strImage: '',

        strVoice: '',

        bImageRequired: el.tiImageRequired == 2 ? true : false,

        bVoiceRequired: el.tiVoiceRequired == 2 ? true : false

      })

    })

  }

  splitItems(item: string): string[] {

    return item.split(';')

  }

  reset_Form_Value() {

    this.lstFInspection_Result = [];

    this.lstPeriodicVisits_Result = [];

    this.list_ValueItems = [];

    this.initial_List_Result();

    this.inspection_Model.patchValue({

      iFInspection: '',

      strComment: '',

      tiFirst_FInspection_ResultItem: '',

      strDeadlineDate: '',

      bBodyinsurance: false,

      bThirdInsurance: false,

      strInsuranceValidityDate: '',

      strEquipmentInspector: '',

      strSafetyInspector: '',

      lstFInspection_Result: ''


    })

    this.periodicVisits_Model.patchValue({

      iPeriodicVisits: '',

      fLat: 0,

      fLon: 0,

      strComment: '',

      lstPeriodicVisits_Result: ''

    })

    this.bViewMode = false;

    $('input[type="radio"]').prop('checked', false);

    $('input[type="checkbox"]').prop('checked', false);

    $('input[type="text"]:not(.input-date)').val('');

  }

  async openModal(item: any) {

    if (this.bVisits) return this.openModal_Periodic(item);

    if (this.bValidation) return this.openModal_Validation(item);

    var model = {

      iFInspection: item.iFInspection,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

    }

    this.otherService.Showspinner();

    const response = await axios.post(`FInspection_Result_List`, model);

    this.otherService.nonespinner()

    let res = JSON.parse(response.data);

    this.reset_Form_Value();

    this.bViewMode = true;

    this.list_ValueItems = res;

    Object.keys(item).forEach(key => {

      this.inspection_Model.get(key)?.setValue(item[key])

    })

    // DOM MANIPULATION

    this.list_Items.forEach((el: any, index: number) => {

      const splitItems = this.splitItems(el.strItems);

      splitItems.forEach((a: any, index: number) => {

        this.isRadioChecked_Edit(el, index)

      })

    })

    // SetValue 4 Inspection

    $('input[type="checkbox"]').eq(item.tiFirst_FInspection_ResultItem).prop('checked', true);

    // SetValue to "lstFInspection_Result"

    this.list_ValueItems.forEach((a: any, index: number) => {

      this.lstFInspection_Result[index].strFInspection_Items_Title = a.strFInspection_Items_Title;

      this.lstFInspection_Result[index].strComment = a.strComment;

      this.lstFInspection_Result[index].tiFInspection_Items_Title_Index = a.tiFInspection_Items_Title_Index;

    })

    $("#Inspection_Modal").modal('show')

  }

  async openModal_Periodic(item: any) {

    //  همه ایتم ها , همراه با مقادیرشان

    var model = {

      iPeriodicVisits: item.iPeriodicVisits,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

    }

    this.otherService.Showspinner();

    const response = await axios.post(`PeriodicVisits_Result_List`, model);

    this.otherService.nonespinner()

    let res = JSON.parse(response.data);

    this.reset_Form_Value();

    this.bViewMode = true;

    this.list_ValueItems = res;

    Object.keys(item).forEach(key => {

      this.periodicVisits_Model.get(key)?.setValue(item[key])

    })

    // DOM MANIPULATION

    this.list_Items.forEach((el: any, index: number) => {

      const splitItems = this.splitItems(el.strItems);

      splitItems.forEach((a: any, index: number) => {

        this.isRadioChecked_Edit(el, index)

      })

    })

    // SetValue to "lstFInspection_Result"

    this.list_ValueItems.forEach((a: any, index: number) => {

      if (this.lstPeriodicVisits_Result[index]) {

        this.lstPeriodicVisits_Result[index].strFInspection_Items_Title = a.strFInspection_Items_Title;

        this.lstPeriodicVisits_Result[index].strComment = a.strComment;

        this.lstPeriodicVisits_Result[index].tiFInspection_Items_Title_Index = a.tiFInspection_Items_Title_Index;

      }

    })

    $("#PeriodicVisit_Modal").modal('show')


  }

  isRadioChecked_Edit(item: any, index: number) {

    this.list_ValueItems.some((el: any, i: number) => {

      if (el.iFInspection_Items == item.iFInspection_Items && el.tiFInspection_Items_Title_Index == index) {

        $(`input[type="radio"][name=${item.iFInspection_Items}]`)

          .eq(el.tiFInspection_Items_Title_Index)

          .prop('checked', true);

      }

      if (el.iFInspection_Items == item.iFInspection_Items && el.strComment.trim() != '') {

        // i + 3 ==> because desire inputs in modal start from 4th in dom

        $('input[type="text"]').eq(i + 3).val(el.strComment)

      }

    });

  }

  openModal_Validation = async (item: any) => {

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

      iMobile_Validation: item.iMobile_Validation

    }

    this.otherService.Showspinner();

    const response = await axios.post(`Mobile_Validation_Images`, model);

    this.otherService.nonespinner();

    let res = JSON.parse(response.data);

    this.validation_Obj = res[0];

    let mapArray = [{

      dLongitude: res[0].fLon_Mobile,

      dLatitude: res[0].fLat_Mobile,

      bHuman: false
    },

    {
      dLongitude: res[0].fLon,

      dLatitude: res[0].fLat,

      bHuman: true
    }

    ];

    setTimeout(() => {

      if (this.validationMap) this.validationMap.setTarget(null);

      var layers2 = [

        new Tile({

          source: new OSM()

        })

      ];

      this.validationMap = new Map({

        target: "map2",

        view: new View({

          zoom: 4,

          center: olProj.fromLonLat([51.3833554, 35.6770113])

        }),

        layers: layers2

      });

      mapArray.forEach((point: any) => {

        let iconSrc;

        if (point.bHuman) iconSrc = '../../assets/Img/man.png';

        else iconSrc = '../../assets/Img/redcarMarker.png';

        const iconStyle = new Style({

          image: new Icon({

            src: iconSrc,

            size: [40, 38],

            anchor: [0.5, 1],

          }),

        });

        const marker = new Feature({ geometry: new Point(olProj.fromLonLat([point.dLongitude, point.dLatitude])) });

        marker.setStyle(iconStyle);

        const vectorSource = new VectorSource({ features: [marker] });

        const vectorLayer = new VectorLayer({ source: vectorSource });

        marker.set('validationData', point)

        this.validationMap.addLayer(vectorLayer);



      });

    }, 500);

    $("#Validation_Modal").modal('show')

  }

}
